// 관리자 상담 콘솔 (2a) — 사용자 상담 요청 목록 + 실시간 응답
// 소켓 support:new / support:message 신호 → 목록/스레드 재조회 (본문은 HTTP).
import React, { useState, useEffect, useRef } from 'react';
import { API, authFetch } from '../utils/api';
import { getSocket } from '../utils/socket';

var STATUS_LABEL = { open: '미응답', answered: '응답함', closed: '종료' };
var STATUS_COLOR = { open: { bg: '#fee2e2', c: '#991b1b' }, answered: { bg: '#dcfce7', c: '#166534' }, closed: { bg: '#f1f5f9', c: '#64748b' } };

function AdminConsult(props) {
  var showToast = props.showToast;
  var _threads = useState([]); var threads = _threads[0]; var setThreads = _threads[1];
  var _filter = useState('all'); var filter = _filter[0]; var setFilter = _filter[1];
  var _active = useState(null); var active = _active[0]; var setActive = _active[1]; // thread id
  var _msgs = useState([]); var msgs = _msgs[0]; var setMsgs = _msgs[1];
  var _reply = useState(''); var reply = _reply[0]; var setReply = _reply[1];
  var _sending = useState(false); var sending = _sending[0]; var setSending = _sending[1];
  var _attUrls = useState({}); var attUrls = _attUrls[0]; var setAttUrls = _attUrls[1];
  var _lightbox = useState(''); var lightbox = _lightbox[0]; var setLightbox = _lightbox[1];
  var bodyRef = useRef(null);
  var activeRef = useRef(null); activeRef.current = active;
  var filterRef = useRef(null); filterRef.current = filter;

  var loadThreads = function () {
    authFetch(API + '/admin/support/threads?status=' + filterRef.current)
      .then(function (r) { return r.json(); })
      .then(function (d) { if (d && d.threads) setThreads(d.threads); })
      .catch(function () {});
  };

  var loadMessages = function (id) {
    if (!id) return;
    authFetch(API + '/admin/support/threads/' + id + '/messages')
      .then(function (r) { return r.json(); })
      .then(function (d) { if (d && d.messages) setMsgs(d.messages); })
      .catch(function () {});
  };

  useEffect(function () { loadThreads(); }, [filter]);

  // 소켓 실시간 신호
  useEffect(function () {
    var sock = null;
    var onSignal = function () {
      loadThreads();
      if (activeRef.current) loadMessages(activeRef.current);
    };
    try { sock = getSocket(); if (sock) { sock.on('support:new', onSignal); sock.on('support:message', onSignal); } } catch (_e) {}
    var poll = setInterval(onSignal, 15000);
    return function () {
      clearInterval(poll);
      try { if (sock) { sock.off('support:new', onSignal); sock.off('support:message', onSignal); } } catch (_e) {}
    };
  }, []);

  useEffect(function () {
    if (bodyRef.current) bodyRef.current.scrollTop = bodyRef.current.scrollHeight;
  }, [msgs]);

  // 첨부 blob 로딩 (인증 필요 → authFetch 후 objectURL 캐시)
  useEffect(function () {
    if (!activeRef.current) return undefined;
    msgs.forEach(function (m) {
      (m.attachments || []).forEach(function (a) {
        if (attUrls[a.id]) return;
        authFetch(API + '/admin/support/threads/' + activeRef.current + '/attachments/' + a.id)
          .then(function (r) { return r.blob(); })
          .then(function (blob) {
            var u = URL.createObjectURL(blob);
            setAttUrls(function (prev) { if (prev[a.id]) return prev; var n = Object.assign({}, prev); n[a.id] = u; return n; });
          }).catch(function () {});
      });
    });
    return undefined;
  }, [msgs]);

  var openThread = function (t) { setActive(t.id); loadMessages(t.id); };

  var sendReply = function () {
    var body = String(reply || '').trim();
    if (!body || sending || !active) return;
    setReply(''); setSending(true);
    authFetch(API + '/admin/support/threads/' + active + '/messages', { method: 'POST', body: JSON.stringify({ body: body }) })
      .then(function (r) { return r.json(); }).then(function (d) {
        setSending(false);
        if (d && d.messageId) { loadMessages(active); loadThreads(); }
        else { setReply(body); showToast && showToast((d && d.error) || '전송 실패', 'error'); }
      }).catch(function () { setSending(false); setReply(body); showToast && showToast('전송 실패', 'error'); });
  };

  var setStatus = function (status) {
    if (!active) return;
    authFetch(API + '/admin/support/threads/' + active, { method: 'PATCH', body: JSON.stringify({ status: status }) })
      .then(function (r) { return r.json(); }).then(function () { loadThreads(); })
      .catch(function () {});
  };

  var onKey = function (e) { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendReply(); } };

  var chip = function (s) {
    var c = STATUS_COLOR[s] || STATUS_COLOR.closed;
    return <span style={{ background: c.bg, color: c.c, padding: '2px 8px', borderRadius: 8, fontSize: 11, fontWeight: 600 }}>{STATUS_LABEL[s] || s}</span>;
  };

  var activeThread = null;
  for (var i = 0; i < threads.length; i++) { if (threads[i].id === active) { activeThread = threads[i]; break; } }

  return (
    <div style={{ display: 'flex', gap: 16, height: 'calc(100vh - 220px)', minHeight: 420 }}>
      {/* 좌: 스레드 목록 */}
      <div style={{ width: 320, display: 'flex', flexDirection: 'column', border: '1px solid #e5e9f0', borderRadius: 10, overflow: 'hidden', background: '#fff' }}>
        <div style={{ display: 'flex', gap: 6, padding: 10, borderBottom: '1px solid #eef1f5' }}>
          {['all', 'open', 'answered', 'closed'].map(function (f) {
            return <button key={f} onClick={function () { setFilter(f); }}
              style={{ flex: 1, padding: '6px 4px', fontSize: 12, fontWeight: 600, cursor: 'pointer', borderRadius: 6,
                border: '1px solid ' + (filter === f ? '#1B3A5C' : '#d5dde8'),
                background: filter === f ? '#1B3A5C' : '#fff', color: filter === f ? '#fff' : '#52627a' }}>
              {f === 'all' ? '전체' : STATUS_LABEL[f]}</button>;
          })}
        </div>
        <div style={{ flex: 1, overflowY: 'auto' }}>
          {threads.length === 0 && <div style={{ padding: 20, color: '#94a3b8', fontSize: 13, textAlign: 'center' }}>상담 요청이 없습니다.</div>}
          {threads.map(function (t) {
            return (
              <div key={t.id} onClick={function () { openThread(t); }}
                style={{ padding: '10px 12px', borderBottom: '1px solid #f0f3f7', cursor: 'pointer',
                  background: active === t.id ? '#eef3f9' : '#fff' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 3 }}>
                  <span style={{ fontSize: 13, fontWeight: 700, color: '#1f2937' }}>{t.user_name || t.user_login || ('user#' + t.user_id)}</span>
                  {chip(t.status)}
                </div>
                <div style={{ fontSize: 12, color: '#64748b', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{t.subject || '(제목 없음)'}</div>
                <div style={{ fontSize: 11, color: '#9aa7b8', marginTop: 2 }}>{t.company_name || ''} · {String(t.updated_at || '').replace('T', ' ').slice(0, 16)}</div>
              </div>
            );
          })}
        </div>
      </div>

      {/* 우: 대화 */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', border: '1px solid #e5e9f0', borderRadius: 10, overflow: 'hidden', background: '#fff' }}>
        {!active ? (
          <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#94a3b8', fontSize: 14 }}>왼쪽에서 상담을 선택하세요.</div>
        ) : (
          <React.Fragment>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 14px', borderBottom: '1px solid #eef1f5' }}>
              <div style={{ fontSize: 14, fontWeight: 700, color: '#1f2937' }}>
                {activeThread ? (activeThread.user_name || activeThread.user_login) : ''} <span style={{ fontWeight: 400, color: '#94a3b8', fontSize: 12 }}>{activeThread ? (activeThread.company_name || '') : ''}</span>
              </div>
              <div style={{ display: 'flex', gap: 6 }}>
                <button onClick={function () { setStatus('closed'); }} style={{ padding: '5px 10px', fontSize: 12, borderRadius: 6, border: '1px solid #d5dde8', background: '#fff', color: '#52627a', cursor: 'pointer' }}>상담 종료</button>
              </div>
            </div>
            <div ref={bodyRef} style={{ flex: 1, overflowY: 'auto', padding: 14, background: '#f6f8fb' }}>
              {msgs.map(function (m, i) {
                var admin = m.sender_kind === 'admin';
                var atts = m.attachments || [];
                return (
                  <div key={m.id || i} style={{ display: 'flex', flexDirection: 'column', alignItems: admin ? 'flex-end' : 'flex-start', marginBottom: 12 }}>
                    <div style={{ fontSize: 11, color: '#94a3b8', margin: '0 2px 3px' }}>{admin ? ('관리자 ' + (m.sender_name || '')) : (m.sender_name || '사용자')}</div>
                    {m.body && m.body !== '(이미지 첨부)' && <div style={{ maxWidth: '78%', padding: '9px 12px', borderRadius: 12, fontSize: 14, lineHeight: 1.5, whiteSpace: 'pre-wrap', wordBreak: 'break-word',
                      background: admin ? '#1B3A5C' : '#fff', color: admin ? '#fff' : '#1f2937', border: admin ? 'none' : '1px solid #e5e9f0' }}>{m.body}</div>}
                    {atts.length > 0 && <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginTop: 4 }}>
                      {atts.map(function (a) {
                        return attUrls[a.id]
                          ? <img key={a.id} src={attUrls[a.id]} alt={a.file_name || 'att'} onClick={function () { setLightbox(attUrls[a.id]); }} style={{ width: 120, height: 120, objectFit: 'cover', borderRadius: 10, border: '1px solid #e5e9f0', cursor: 'zoom-in' }} />
                          : <div key={a.id} style={{ width: 120, height: 120, borderRadius: 10, border: '1px solid #e5e9f0', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#b6c2d4', fontSize: 24 }}>🖼️</div>;
                      })}
                    </div>}
                  </div>
                );
              })}
            </div>
            <div style={{ display: 'flex', gap: 8, padding: 10, borderTop: '1px solid #eef1f5' }}>
              <textarea value={reply} onChange={function (e) { setReply(e.target.value); }} onKeyDown={onKey} rows={2}
                placeholder="답변을 입력하세요… (Enter 전송, Shift+Enter 줄바꿈)"
                style={{ flex: 1, resize: 'none', border: '1px solid #d5dde8', borderRadius: 8, padding: '9px 11px', fontSize: 14, fontFamily: 'inherit' }} />
              <button onClick={sendReply} disabled={sending || !reply.trim()}
                style={{ border: 'none', borderRadius: 8, background: sending || !reply.trim() ? '#b6c2d4' : '#1B3A5C', color: '#fff', padding: '0 18px', fontSize: 14, fontWeight: 700, cursor: 'pointer' }}>전송</button>
            </div>
          </React.Fragment>
        )}
      </div>
      {lightbox && <div onClick={function () { setLightbox(''); }} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', zIndex: 999999, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'zoom-out' }}>
        <img src={lightbox} alt="zoom" style={{ maxWidth: '94vw', maxHeight: '94vh', borderRadius: 8 }} />
      </div>}
    </div>
  );
}

export default AdminConsult;
